const BALANCED_MELEE = {
  slash: {
    hitbox: { w: 65, h: 78, offsetX: 42, offsetY: -16 },
    damage: 15,
    activeStartMs: 100,
    activeEndMs: 250,
    cooldownMs: 400,
    knockbackX: 1.6,
    hitStopMs: { attacker: 35, target: 65 },
  },
  kick: {
    hitbox: { w: 20, h: 40, offsetX: 30, offsetY: 4 },
    damage: 20,
    activeStartMs: 100,
    activeEndMs: 200,
    cooldownMs: 400,
    knockbackX: 2.2,
    hitStopMs: { attacker: 30, target: 70 },
  },
};

const BALANCED_THROW = {
  default: {
    speed: 8,
    lifetimeMs: 700,
    w: 10,
    h: 10,
    cooldownMs: 300,
    knockbackX: 1.2,
  },
  food_throwable: {
    speed: 7.5,
    lifetimeMs: 700,
    w: 10,
    h: 10,
    cooldownMs: 300,
    knockbackX: 1.2,
    hitStopMs: { attacker: 20, target: 55 },
  },
};

const BALANCED_NETWORK = {
  respawnProtectionMs: 1200,
  dyingDurationMs: 500,
  respawnTransitionMs: 50,
  maxLatencyCompMs: 140,
  maxMessageBytes: 4096,
  maxMessagesPerWindow: 140,
  messageWindowMs: 1000,
};

function mergeWeaponProfile(base, override) {
  return {
    ...base,
    ...override,
    hitbox: { ...(base?.hitbox || {}), ...(override?.hitbox || {}) },
    hitStopMs: { ...(base?.hitStopMs || {}), ...(override?.hitStopMs || {}) },
  };
}

function mergeThrowProfile(base, override) {
  return {
    ...base,
    ...override,
    hitStopMs: { ...(base?.hitStopMs || {}), ...(override?.hitStopMs || {}) },
  };
}

export const COMBAT_PRESETS = {
  balanced: {
    melee: BALANCED_MELEE,
    throwables: BALANCED_THROW,
    network: BALANCED_NETWORK,
  },
  arcade: {
    melee: {
      slash: mergeWeaponProfile(BALANCED_MELEE.slash, { damage: 24, cooldownMs: 330, knockbackX: 1.9 }),
      kick: mergeWeaponProfile(BALANCED_MELEE.kick, { damage: 28, cooldownMs: 350, knockbackX: 2.5 }),
    },
    throwables: {
      default: mergeThrowProfile(BALANCED_THROW.default, { speed: 9, cooldownMs: 260 }),
      food_throwable: mergeThrowProfile(BALANCED_THROW.food_throwable, { speed: 8.4, cooldownMs: 260 }),
    },
    network: {
      ...BALANCED_NETWORK,
      maxLatencyCompMs: 160,
      maxMessagesPerWindow: 170,
    },
  },
  heavyweight: {
    melee: {
      slash: mergeWeaponProfile(BALANCED_MELEE.slash, { damage: 26, cooldownMs: 460, knockbackX: 2.2 }),
      kick: mergeWeaponProfile(BALANCED_MELEE.kick, { damage: 32, cooldownMs: 520, knockbackX: 2.9 }),
    },
    throwables: {
      default: mergeThrowProfile(BALANCED_THROW.default, { speed: 7, cooldownMs: 420, knockbackX: 1.6 }),
      food_throwable: mergeThrowProfile(BALANCED_THROW.food_throwable, { speed: 6.8, cooldownMs: 420, knockbackX: 1.6 }),
    },
    network: {
      ...BALANCED_NETWORK,
      maxLatencyCompMs: 130,
      maxMessagesPerWindow: 120,
    },
  },
};

export const DEFAULT_COMBAT_PRESET = "balanced";

export function resolveCombatTuning(rawPreset) {
  const presetName = typeof rawPreset === "string" ? rawPreset.trim().toLowerCase() : "";
  const resolvedName = COMBAT_PRESETS[presetName] ? presetName : DEFAULT_COMBAT_PRESET;
  const preset = COMBAT_PRESETS[resolvedName];
  return {
    preset: resolvedName,
    melee: {
      slash: mergeWeaponProfile(BALANCED_MELEE.slash, preset.melee?.slash || {}),
      kick: mergeWeaponProfile(BALANCED_MELEE.kick, preset.melee?.kick || {}),
    },
    throwables: {
      default: mergeThrowProfile(BALANCED_THROW.default, preset.throwables?.default || {}),
      food_throwable: mergeThrowProfile(BALANCED_THROW.food_throwable, preset.throwables?.food_throwable || {}),
    },
    network: {
      ...BALANCED_NETWORK,
      ...(preset.network || {}),
    },
  };
}

const DEFAULT_RESOLVED = resolveCombatTuning(DEFAULT_COMBAT_PRESET);
export const MELEE_TUNING = DEFAULT_RESOLVED.melee;
export const THROW_TUNING = DEFAULT_RESOLVED.throwables;
export const COMBAT_NETWORK_TUNING = DEFAULT_RESOLVED.network;
